// Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/chitconnect-logo.png';
import './Sidebar.css';
import {
  FaBars, FaHome, FaUsersCog, FaMoneyBill,
  FaChartBar, FaCog, FaSignOutAlt, FaUserPlus, FaUniversity, FaBell
} from 'react-icons/fa';

import { FaComments } from 'react-icons/fa';

export default function Sidebar({ collapsed, toggle, mobileOpen, onLinkClick, user, onLogout }) {
  const access = user?.access_level || 1;

  // Hide sidebar on small screens for normal users unless explicitly opened
  if (access === 1 && window.innerWidth < 768 && !mobileOpen) return null;

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <img src={logo} alt="ChitConnect" className={`logo ${collapsed ? 'collapsed' : ''}`} />
        {window.innerWidth >= 768 && (
          <button className="toggle-btn" onClick={toggle}><FaBars /></button>
        )}
      </div>

      <ul>
        {user ? (
          <>
            <li title="Home">
              <NavLink
                to="/"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaHome /> {!collapsed && 'Home'}
              </NavLink>
            </li>

            <li title="Groups">
              <NavLink
                to="/groups"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaMoneyBill /> {!collapsed && 'Groups'}
              </NavLink>
            </li>

            <li title="Bank Details">
              <NavLink
                to="/bank-details"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaUniversity /> {!collapsed && 'Bank Details'}
              </NavLink>
            </li>

            <li title="My Payments">
              <NavLink
                to="/payments"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaMoneyBill /> {!collapsed && 'My Payments'}
              </NavLink>
            </li>

            <li title="Review Payments">
              <NavLink
                to="/payments/review"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaChartBar /> {!collapsed && 'Review Payments'}
              </NavLink>
            </li>

            <li title="Notifications">
              <NavLink
                to="/notifications"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaBell /> {!collapsed && 'Notifications'}
              </NavLink>
            </li>

            <li title="Messages">
              <NavLink
                to="/messages"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaComments /> {!collapsed && 'Messages'}
              </NavLink>
            </li>

            <li title="Edit Profile">
              <NavLink
                to="/edit-profile"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaUsersCog /> {!collapsed && 'Edit Profile'}
              </NavLink>
            </li>

            <li title="Change Password">
              <NavLink
                to="/change-password"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaCog /> {!collapsed && 'Change Password'}
              </NavLink>
            </li>

            {(access === 3 || access === 4) && (
              <>
                <li title="Reports">
                  <NavLink
                    to="/reports"
                    onClick={onLinkClick}
                    className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  >
                    <FaChartBar /> {!collapsed && 'Reports'}
                  </NavLink>
                </li>
                <li title="Auction Settings">
                  <NavLink
                    to="/auction-settings"
                    onClick={onLinkClick}
                    className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  >
                    <FaCog /> {!collapsed && 'Auction Settings'}
                  </NavLink>
                </li>
              </>
            )}

            {access === 4 && (
              <>
                <li title="User Management">
                  <NavLink
                    to="/users"
                    onClick={onLinkClick}
                    className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  >
                    <FaUsersCog /> {!collapsed && 'User Management'}
                  </NavLink>
                </li>
                <li title="Settings">
                  <NavLink
                    to="/settings"
                    onClick={onLinkClick}
                    className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  >
                    <FaCog /> {!collapsed && 'Settings'}
                  </NavLink>
                </li>
              </>
            )}

            <li>
              <button className="nav-link logout-btn" onClick={onLogout}>
                <FaSignOutAlt /> {!collapsed && 'Logout'}
              </button>
            </li>
          </>
        ) : (
          <>
            <li title="Home">
              <NavLink
                to="/"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaHome /> {!collapsed && 'Home'}
              </NavLink>
            </li>
            <li title="Register">
              <NavLink
                to="/register"
                onClick={onLinkClick}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <FaUserPlus /> {!collapsed && 'Register'}
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
